/**
 * Apis Tuijncode Request Row Style.
 *
 * Highlights non-2xx responses (anything other than HTTP 200) with a red row.
 */
window.apisTuijncodeRequestRowStyle = function(row, index) {
    if (row.status && parseInt(row.status, 10) !== 200) {
        return {
            classes: 'table-danger'
        };
    }
    return {};
};
